const darkTheme = outerTheme => {
  outerTheme['pelette'] = {
    type: 'dark'
  };
  return outerTheme;
};

export default darkTheme;
